function launchCustomizer(e) {
	e.preventDefault();
	e.stopPropagation();
	let that = this;
	const customerId = prodObj.customerId;
	const current_product_id = prodObj.productId;
	if (customerId) {
		window.laudividni.setDesignerId(customerId);
	}
	//Update API to
	let designer = window.laudividni.openDesignTool(lastVariantSku, function (designObj) {
		designer.close();
		if (designObj.action === 'Add To Cart') {
			setTimeout(function () {
				const $customBtn = $(".custom-design-button");
				if ($customBtn.length) {
					$customBtn.click();
				}
			}, 2000);
		}
		let url = window.location.pathname + "?design=" + designObj.product.design.id;
		let productHash = {
			product: current_product_id,
			design_product: [{
				designProduct: designObj.product,
				created_at: new Date().toISOString(),
				url
			}]
		};
		if (localStorage.getItem("customDesign--" + current_product_id)) {
			let currentDesigns = JSON.parse(localStorage.getItem("customDesign--" + current_product_id));
			currentDesigns.design_product.push({
				designProduct: designObj.product,
				created_at: new Date().toISOString(),
				url,
			});
			localStorage.setItem("customDesign--" + current_product_id,
				JSON.stringify({
					product: current_product_id,
					design_product: currentDesigns.design_product
				})
			);
		} else {
			localStorage.setItem("customDesign--" + current_product_id, JSON.stringify(productHash));
		}
		updateImages(designObj, current_product_id);
		if (that.savedDesignInitialized) {
			document.querySelector('.main-desgin').click();
			setTimeout(() => {
				document.querySelector('.custom_design_tab').click();
				that.savedDesignInitialized = false;
			}, 500);
		} else {
			setTimeout(() => {
				document.querySelector('.custom_design_tab').click();
			}, 500);
		}
		setTimeout(() => window.dispatchEvent(new CustomEvent('customDesignSaved', {
			bubbles: true,
			detail: designObj
		})), 100);
	}, {
		btnLabel: ['Save Your Design', 'Add To Cart'],
	});
}

function savedDesignsInit() {
	const handleDeeplinkingToDesign = () => {
		var urlParams = new URLSearchParams(window.location.search);
		var designId = urlParams.get('design') ?? null;
  
		// Check if the "design" parameter exists in the query string
		// but only if we are not attempting to deeplink to a variant
		if (!urlParams.has('variant') && designId) {
			var btnTab = document.querySelector('a.custom_design_tab[href="#tab2"]');
			var btnItem = document.querySelector('.carousel-cell[data-design-id="' + designId + '"]');
			if (btnTab) btnTab.click();
			if (btnItem) setTimeout(btnItem.click, 100);
		}
	}

	const clearSavedDesign = (designId) => {
		const designsByProductId = Object.entries(localStorage)
			.filter(([key]) => key.startsWith("customDesign--"))
			.forEach(([key, value]) => {
				const designs = JSON.parse(value);
				const oldCount = designs.design_product.length;
				designs.design_product = designs.design_product.filter(design => design.designProduct.design.id != designId);

				if (oldCount !== designs.design_product.length) {
					localStorage.setItem(key, JSON.stringify(designs));
				}
			});
	};

	const getSavedDesigns = () => {
		return Object.entries(localStorage)
			.filter(([key]) => key.startsWith("customDesign--"))
			.map(([key, json]) => JSON.parse(json))
			.flatMap(({
					product,
					design_product
				}) =>
				design_product.map(({
					created_at,
					designProduct,
					url
				}) => ({
					productId: product,
					createdAt: created_at,
					design: designProduct,
					url,
				}))
			);
	};

	function checkItemsCount() {
		if ($(".saved-designs-drawer__item").length) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--empty");
		} else {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active").addClass("saved-designs-drawer--empty");
		}
	}

	function renderItems() {
		var savedDesigns = getSavedDesigns().map(item => {
			return {
				id: item.design.design.id,
				title: item.design.design.design.name,
				price: `$${item.design.design.design.price / 100}`,
				image: item.design.design.image,
				url: item.url,
			};
		});

		$(".saved-designs-drawer__item").remove();
		
		$.each(savedDesigns, function () {

			$(".saved-designs-drawer__panel").append(
				"<div class='saved-designs-drawer__item' data-saved-product-design-id='" + this.id + "'>" +
				"<a class='saved-designs-drawer__item-media' href='" + this.url + "' aria-label='View " + this.title + "'>" +
				"<img class='saved-designs-drawer__item-image' src='" + this.image + "' alt='" + this.title + "'/>" +
				"</a>" +
				"<div class='saved-designs-drawer__item-detail'>" +
				"<a class='saved-designs-drawer__item-title' href='#' aria-label='View " + this.title + "'>" + this.title + "</a>" +
				"<div class='saved-designs-drawer__item-price'>Designed at " + this.price + "</div>" +
				"<a class='saved-designs-drawer__item-btn' href='" + this.url + "' aria-label='View Design'>View Design</a>" +
				"<a class='saved-designs-drawer__item-btn saved-designs-drawer__item-btn--alt' onclick='GorgiasChat.open();' aria-label='View Expert&lsquo;s Advice'>Expert&lsquo;s Advice</a>" +
				"</div>" +
				"<button class='saved-designs-drawer__item-remove' aria-label='Remove Item'></button>" +
				"</div>"
			);
		});

		$(".saved-designs-drawer__item-remove").on("click", function () {
			const item = $(this).parents(".saved-designs-drawer__item"),
				itemId = item.attr('data-saved-product-design-id');

			item.fadeOut(200, function () {
				$(this).remove();
				checkItemsCount();
			});
			clearSavedDesign(itemId);
		});

		checkItemsCount();
	}

	$(".saved-designs-drawer__tab").on("click", function () {
		if ($(".saved-designs-drawer").hasClass("saved-designs-drawer--active")) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active");
			$("body").removeClass("saved-designs-drawer--active");
		} else {
			$(".saved-designs-drawer").addClass("saved-designs-drawer--active");
			$("body").addClass("saved-designs-drawer--active");
		}
	});

	renderItems();
	setTimeout(() => handleDeeplinkingToDesign(), 1500);
	window.addEventListener('customDesignSaved', (e) => renderItems());
}

function customizeInit() {
	$('.customize-opener').click((e) => {
		e.stopPropagation();
		launchCustomizer(e);
	});
	$(document).on('click', '.custom_design_tab', function (e) {
		e.preventDefault();
		e.stopPropagation();
		setTimeout(() => {
			this.savedDesignInitialized = true;
			$('.customize-opener').click((e) => {
				launchCustomizer(e);
			});
		}, 0);
	});
	const variantButtons = Array.from(document.querySelectorAll("input[name=Color]"));
	variantButtons.forEach((btn) => {
		btn.addEventListener("click", (e) => {
			const newSku = e.currentTarget.getAttribute('data-sku');
			const customizeOpener = document.querySelector('.customize-opener');
			if (customizeOpener) {
				customizeOpener.setAttribute('data-sku', newSku);
			}
		});
	});
	$(".design-tabs > li > a").attr("data-no-instant", true);
	$(document).on("click", ".design-tabs > li > a:not(.active)", function (e) {
		e.preventDefault();
		const $this = $(this);
		const selector = $this.attr("href");
		$(".design-tabs > li > a").removeClass('active');
		$this.addClass('active');
		$('.design-tabs-content li').removeClass('active');
		$(`.design-tabs-content li${selector}`).addClass('active');
		const isMainTab = $this.hasClass('main-desgin');
		$('.product-form__buttons > .button').toggle(isMainTab);
		$('.purchase-details__buttons > a,.purchase-details__buttons > button').toggle(!isMainTab);
		$(".item_details").html('');
		if (isMainTab) {
			$(".Custom-Design").hide();
			updateVariantInfo(prodObj.productSku);
		} else {
			const designData = localStorage.getItem("customDesign--" + $(this).data("product"));
			if (designData) {
				let customDesignHash = JSON.parse(designData);
				let customDesign = customDesignHash.design_product;
				let smallestIndex = [],
					customHash = [];
				customDesign.forEach(
					(item, index, object) => {
						let today = new Date();
						let recordDate = new Date(item.created_at);
						const diffTime = Math.abs(today - recordDate);
						const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
						smallestIndex.push(recordDate);
						customHash.push({
							index: index,
							days: recordDate
						});
						if (diffDays >= 15) {
							object.splice(index, 1);
						}
					}
				);
				if (customDesign.length > 0) {
					let index = 0;
					let maxDate = new Date(Math.max.apply(null, smallestIndex)).getTime();
					customHash.forEach(function (element) {
						if (maxDate == element.days.getTime()) {
							index = element.index;
						}
					})
					customDesignHash.design_product = customDesign;
					localStorage.setItem("customDesign--" + $(this).data("product"), JSON.stringify(customDesignHash));
					updateVariantInfo(customDesign[index].designProduct.design.design.sku);
					let values = customDesign[index].designProduct.design.design.values;
					$(".current_price").text(Shopify.formatMoney(customDesign[index].designProduct.price, "${{amount}}"));
					$(".main-carousel").html("");
					customDesign.forEach(
						(item, i) => {
							let classList = "";
							if (i == index) {
								classList = "Selected"
							}
							$(".main-carousel").append(
								`<div class="carousel-cell" data-ATC="` + item.designProduct.addToCart + `" data-design-id="` + item.designProduct.design.id + `"> <img design-data='` + JSON.stringify(item.designProduct) + `' class="` + classList + `"  data-price="` + item.designProduct.price + `" data-ATC="` + item.designProduct.addToCart + `" src="` + item.designProduct.thumbnail + `" width="150" height="150"  ></div>`
							);
						}
					);
					$(".custom-design-button").remove();
					$(".custom-button").remove();
					$(".purchase-details__buttons").append(`
						<a data-sku="${customDesign[index].designProduct.design.design.sku}" class="button button--primary action_button customize-opener custom-button" >
							<img width="11" height="21" class="cc-customize-icon" aria-hidden="true" src="https://cdn.shopify.com/s/files/1/0374/1561/6643/files/LV_Paintbrush-white.webp?v=1695725675" alt="">
							Customize Yours
						</a>
						<button type="button" name="add" aria-haspopup="dialog" id="add-design-btn" data-original-product="${$(this).attr("data-product")}" class="button button--secondary product-form__submit custom-design-button action_button add_to_cart" data-action="${customDesign[index].designProduct.addToCart}" data-label="Add to Cart"> 
							ADD TO CART
						</button>
					`);
				} else {
					localStorage.removeItem("customDesign--" + $(this).attr("data-product"));
				}
			}
		}
	});
	$(document).on("click", ".custom-button", function () {
		var LeatherName = $(".item_details .value").text();
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'saved_design',
			ecommerce: {
				detail: {
					products: [{
						id: prodObj.productId,
						name: prodObj.productTitle,
						category: prodObj.category,
						leather: 'leather_name',
						lining: prodObj.lining,
						hardware: '+ value.value_name +',
						price: prodObj.variantPrice,
					}]
				}
			}
		});
	});
}
function eventsInit() {
	$(document).on('click', '.thumbnail-slider .thumbnail', function (e) {
		$('.gallery-image').addClass('shown');
		$('.product_gallery').addClass('hidden');
	});
	$(document).on('click', '.main-carousel img', function (e) {
		let imgData = JSON.parse($(this).attr("design-data"));
		let skuVal = imgData.design.design.sku;
		$(".main-carousel img").removeClass("Selected");
		$(".Custom-Design .product_gallery img").attr("src", $(this).attr("src"));
		$(".current_price").text(Shopify.formatMoney(this.dataset.price, "${{amount}}"));
		$(".custom-design-button").attr("data-action", $(this).attr("data-atc"));
		$(".custom-design-button").next().attr("data-sku", skuVal);
		let designInfo = JSON.parse($(this).attr("design-data"));
		if (designInfo) {
			updateVariantInfo(designInfo.design.design.sku);
			let values = designInfo.design.design.values;
			$(".item_details").html('');
		}
		$(this).addClass("Selected");
	});
	$(document).on('click', '.custom-design-button', function (e) {
		e.preventDefault();
		let elem = document.getElementById("add-design-btn");
		elem.textContent = "Adding to cart...";
		let atcAtttr = $(this).attr("data-action");
		let originalProduct = $(this).attr("data-original-product");
		let customDesignHash = JSON.parse(localStorage.getItem("customDesign--" + $(this).attr("data-original-product")));
		let customDesign = customDesignHash.design_product;
		let selectedIndex = 0,
			isCreated = false;
		var $addToCartForm = $(this).closest('form');
		var $addToCartBtn = $addToCartForm.find('.custom-design-button');
		$addToCartBtn = $(this);
		$addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
		$addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
		customDesign.forEach((item, index) => {
			if (item.designProduct.addToCart == atcAtttr) {
				selectedIndex = index;
				if (item.variant_id || item.product_id) {
					isCreated = true;
				}
			}
		});
		if (atcAtttr.includes("ngrok.io")) {
			atcAtttr = atcAtttr.split("ngrok.io")[1];
			atcAtttr = 'https://app.unitmoq.com' + atcAtttr;
		}
		
		if (!isCreated) {
			$.get(atcAtttr, function (data) {
				if (data) {
					customDesign[selectedIndex].variant_id = data.variant_id;
					customDesign[selectedIndex].product_id = data.product_id;
					customDesignHash.design_product = customDesign;
					localStorage.setItem("customDesign--" + originalProduct, JSON.stringify(customDesignHash));
					let obj = {};
					let values = JSON.parse(sessionStorage["sku-" + customDesign[selectedIndex].designProduct.design.design.sku])
					values = values.values;
					values.forEach(function (element) {
						if (element.value_name != "" && element.value_name != "n/a") {
							obj[element.component_name] = element.value_name;
						}
					});
					let Cartdata = {
						"id": data.variant_id,
						"quantity": 1,
						"properties": obj
					}
					jQuery.ajax({
						type: 'POST',
						url: '/cart/add.js',
						data: Cartdata,
						dataType: 'json',
						success: function (data) {
							jQuery.ajax({
								type: 'GET',
								url: '/cart.js',
								dataType: 'json',
								success: function (cart) {
									if (window.innerWidth > 600) {
										refreshCart(cart);
									} else {
										window.location.href = "/cart";
									}
									elem.textContent = "Added to Cart";
									elem.classList.add('added');
								}
							})
						}
					});
				}
			});
		} else {
			let obj = {};
			let values = JSON.parse(sessionStorage["sku-" + customDesign[selectedIndex].designProduct.design.design.sku]) //customDesign[selectedIndex].designProduct.design.design.values
			values = values.values;
			values.forEach(function (element) {
				if (element.value_name != "" && element.value_name != "n/a") {
					obj[element.component_name] = element.value_name;
				}
			});
			let Cartdata = {
				"id": customDesign[selectedIndex].variant_id,
				"quantity": 1,
				"properties": obj
			}
			jQuery.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: Cartdata,
				dataType: 'json',
				success: function (data) {
					jQuery.ajax({
						type: 'GET',
						url: '/cart.js',
						dataType: 'json',
						success: function (cart) {
							if (window.innerWidth > 600) {
								refreshCart(cart);
							} else {
								window.location.href = "/cart";
							}
							elem.textContent = "Added to Cart";
							elem.classList.add('added');
						}
					})
				}
			});
		}
	});
}

function updateVariantInfo(sku_override) {
	const sku = sku_override ? sku_override : $('.product-variant-sku').val();
	const $itemInfoList = $('.item_details');
	if (sku) {
		if (!Shopify.designMode) {
			$('.variant-loader').show();
		}
		try {
			window.x.loadPreview(document.getElementById('product-preview-container'), sku, (data) => {
				$('.variant-loader').hide();
				$('.gallery-image').removeClass('shown');
				$('.product_gallery').removeClass('hidden');
				$(".item_details").html('');
				sessionStorage.setItem("sku-" + data.sku, JSON.stringify(data));
				let values = data.values;
				if (($("#tab2.active").length > 0 && $("#tab2 .main-carousel").html() != "") || !$('#tab2').length) {
					values.forEach(function (value, indexValue) {
						if (value.value_name != "n/a") {
							$("form.product-form").append(`<input type="hidden" class="hidden-attributes" name="properties[` + value.component_name + `]" value="` + value.value_name + `" />`)
							$(".item_details").append(`<li><span class="heading"> ` + value.component_name + `: </span> <span class="value">` + value.value_name + `</span></li>`);
						}
					});
				} else {
					values.forEach(function (value, indexValue) {
						if (value.value_name != "n/a") {
							$("form.product-form").append(`<input type="hidden" class="hidden-attributes" name="properties[` + value.component_name + `]" value="` + value.value_name + `" />`)
							$(".item_details").append(`<li><span class="heading"> ` + value.component_name + `: </span> <span class="value">` + value.value_name + `</span></li>`);
						}
					})
				}
				if (values.length > 0) {
					$itemInfoList.addClass('shown');
				}
				lastVariantSku = data.sku;
				$('.product-variant-sku').val(data.sku);
				$('html').animate( { scrollTop: 0 }, 0);
			});
		} catch (error) {
			console.log('err', error);
		}
	}
}

function refreshCart(cart) {
	window.location.reload();
}
function updateImages(designObj, product_id) {
	$(".Custom-Design .product_gallery img").attr("src", designObj.product.thumbnail);
	$(".Custom-Design").show();
	$(".Custom-Design .product_gallery").css("opacity", 1);
	$(".Custom-Design .product_gallery img").css("opacity", 1);
	$(".Custom-Design .product_gallery .thumbnail").css("visibility", "visisble");
	$(".current_price").text(Shopify.formatMoney(designObj.product.price, $('body').data('money-format')));
	let customDesign = JSON.parse(localStorage.getItem("customDesign--" + product_id)).design_product;
	if (customDesign.length) {
		$(".main-carousel").empty();
		customDesign.forEach(
			(item) => {
				$(".main-carousel").append(
					`<div class="carousel-cell" data-ATC='` + item.designProduct.addToCart + `'> <img design-data='` + JSON.stringify(item.designProduct) + `' src='` + item.designProduct.thumbnail + `' width="150" height="150"  ></div>	`
				);
			}
		);
	}
}

let lastVariantSku = $('.product-variant-sku').val();
let colorCount = $('.product-form__input--pill input[name=Color]').length;
if (colorCount == 1) {
	$(document).on('click', 'variant-selects', () => updateVariantInfo());
}
let prodObj = $('.product').data('obj');
eventsInit();
customizeInit();
savedDesignsInit();
updateVariantInfo();

class VariantSelects extends HTMLElement {
	constructor() {
	  super();
	  this.addEventListener('change', this.onVariantChange);
	  this.variantElement = document.querySelector('input[name=id],select[name=id]');
	  this.savedDesignInitialized = false;
	}
	
	onVariantChange(event) {
	  this.updateOptions();
	  this.updateMasterId();
	  this.updateSelectedSwatchValue(event);
	  this.toggleAddButton(true, '', false);
	  this.updatePickupAvailability();
	  this.removeErrorMessage();
	  this.updateVariantStatuses();
  
	  if (!this.currentVariant) {
		this.toggleAddButton(true, '', true);
		this.setUnavailable();
	  } else {
		this.updateURL();
		this.updateVariantInput();
		this.renderProductInfo();
		updateVariantInfo();
		this.updateShareUrl();
	  }
	}

	updateOptions() {
	  this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
		if (element.tagName === 'SELECT') {
		  return element.value;
		}
		if (element.tagName === 'FIELDSET') {
		  return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
		}
	  });
	}
  
	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
			.map((option, index) => {
				return this.options[index] === option;
			})
			.includes(false);
		});
	}
  
	updateSelectedSwatchValue({ target }) {
	  const { name, value, tagName } = target;
  
	  if (tagName === 'SELECT' && target.selectedOptions.length) {
		const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
		const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
		if (!selectedDropdownSwatchValue) return;
		if (swatchValue) {
		  selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
		  selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
		} else {
		  selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
		  selectedDropdownSwatchValue.classList.add('swatch--unavailable');
		}
  
		selectedDropdownSwatchValue.style.setProperty(
		  '--swatch-focal-point',
		  target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
		);
	  } else if (tagName === 'INPUT' && target.type === 'radio') {
		const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
		if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
	  }
	}
  
	updateURL() {
	  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
	  window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
  
	updateShareUrl() {
	  const shareButton = document.getElementById(`Share-${this.dataset.section}`);
	  if (!shareButton || !shareButton.updateUrl) return;
	  shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
  
	updateVariantInput() {
	  const productForms = document.querySelectorAll(
		`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
	  );
	  productForms.forEach((productForm) => {
		const input = productForm.querySelector('input[name="id"]');
		input.value = this.currentVariant.id;
		input.dispatchEvent(new Event('change', { bubbles: true }));
	  });
	}
  
	updateVariantStatuses() {
	  const selectedOptionOneVariants = this.variantData.filter(
		(variant) => this.querySelector(':checked').value === variant.option1
	  );
	  const inputWrappers = [...this.querySelectorAll('.product-form__input')];
	  inputWrappers.forEach((option, index) => {
		if (index === 0) return;
		const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
		const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
		const availableOptionInputsValue = selectedOptionOneVariants
		  .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
		  .map((variantOption) => variantOption[`option${index + 1}`]);
		this.setInputAvailability(optionInputs, availableOptionInputsValue);
	  });
	}
  
	setInputAvailability(elementList, availableValuesList) {
	  elementList.forEach((element) => {
		const value = element.getAttribute('value');
		const availableElement = availableValuesList.includes(value);
  
		if (element.tagName === 'INPUT') {
		  element.classList.toggle('disabled', !availableElement);
		} else if (element.tagName === 'OPTION') {
		  element.innerText = availableElement
			? value
			: window.variantStrings.unavailable_with_option.replace('[value]', value);
		}
	  });
	}
  
	updatePickupAvailability() {
	  const pickUpAvailability = document.querySelector('pickup-availability');
	  if (!pickUpAvailability) return;
  
	  if (this.currentVariant && this.currentVariant.available) {
		pickUpAvailability.fetchAvailability(this.currentVariant.id);
	  } else {
		pickUpAvailability.removeAttribute('available');
		pickUpAvailability.innerHTML = '';
	  }
	}
  
	removeErrorMessage() {
	  const section = this.closest('section');
	  if (!section) return;
  
	  const productForm = section.querySelector('product-form');
	  if (productForm) productForm.handleErrorMessage();
	}
  
	updateMedia(html) {
	  const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
	  const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
  
	  const refreshSourceData = () => {
		const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
		const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
		const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
		return [mediaGallerySourceItems, sourceSet, sourceMap];
	  };
  
	  if (mediaGallerySource && mediaGalleryDestination) {
		let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
		const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
		const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
		let shouldRefresh = false;
		// add items from new data not present in DOM
		for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
		  if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
			mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
			shouldRefresh = true;
		  }
		}
  
		// remove items from DOM not present in new data
		for (let i = 0; i < mediaGallerySourceItems.length; i++) {
		  if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
			mediaGallerySourceItems[i].remove();
			shouldRefresh = true;
		  }
		}
  
		// refresh
		if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
  
		// if media galleries don't match, sort to match new data order
		mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
		  const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
  
		  if (sourceData && sourceData.index !== destinationIndex) {
			mediaGallerySource.insertBefore(
			  sourceData.item,
			  mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
			);
  
			// refresh source now that it has been modified
			[mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
		  }
		});
	  }
  
	  if (this.currentVariant.featured_media) {
		document
		  .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
		  ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
	  }
  
	  // update media modal
	  const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
	  const newModalContent = html.querySelector(`product-modal`);
	  if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
	}
  
	renderProductInfo() {
	  const requestedVariantId = this.currentVariant.id;
	  const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
	  $('.product-variant-sku').val(this.currentVariant.sku);
	  fetch(
		`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
		  this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
		}`
	  )
		.then((response) => response.text())
		.then((responseText) => {
		  // prevent unnecessary ui changes from abandoned selections
		  if (this.currentVariant.id !== requestedVariantId) return;
  
		  const html = new DOMParser().parseFromString(responseText, 'text/html');
		  const destination = document.getElementById(`price-${this.dataset.section}`);
		  const source = html.getElementById(
			`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const skuSource = html.getElementById(
			`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
		  const inventorySource = html.getElementById(
			`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
		  const volumePricingSource = html.getElementById(
			`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
  
		  // this.updateMedia(html);
  
		  const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
		  const pricePerItemSource = html.getElementById(
			`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
  
		  const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
		  const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
		  const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
  
		  if (volumeNote) volumeNote.classList.remove('hidden');
		  if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
		  if (qtyRules) qtyRules.classList.remove('hidden');
  
		  if (source && destination) destination.innerHTML = source.innerHTML;
		  if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
		  if (skuSource && skuDestination) {
			skuDestination.innerHTML = skuSource.innerHTML;
			skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
		  }
  
		  if (volumePricingSource && volumePricingDestination) {
			volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
		  }
  
		  if (pricePerItemSource && pricePerItemDestination) {
			pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
			pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
		  }
  
		  const price = document.getElementById(`price-${this.dataset.section}`);
  
		  if (price) price.classList.remove('hidden');
  
		  if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
  
		  const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
		  this.toggleAddButton(
			addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
			window.variantStrings.soldOut
		  );
  
		  publish(PUB_SUB_EVENTS.variantChange, {
			data: {
			  sectionId,
			  html,
			  variant: this.currentVariant,
			},
		  });
		});
	}
  
	toggleAddButton(disable = true, text, modifyClass = true) {
	  const productForm = document.getElementById(`product-form-${this.dataset.section}`);
	  if (!productForm) return;
	  const addButton = productForm.querySelector('[name="add"]');
	  const addButtonText = productForm.querySelector('[name="add"] > span');
	  if (!addButton) return;
  
	  if (disable) {
		addButton.setAttribute('disabled', 'disabled');
		if (text) addButtonText.textContent = text;
	  } else {
		addButton.removeAttribute('disabled');
		addButtonText.textContent = window.variantStrings.addToCart;
	  }
  
	  if (!modifyClass) return;
	}
  
	setUnavailable() {
	  const button = document.getElementById(`product-form-${this.dataset.section}`);
	  const addButton = button.querySelector('[name="add"]');
	  const addButtonText = button.querySelector('[name="add"] > span');
	  const price = document.getElementById(`price-${this.dataset.section}`);
	  const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
	  const sku = document.getElementById(`Sku-${this.dataset.section}`);
	  const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
	  const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
	  const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
	  const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
  
	  if (!addButton) return;
	  addButtonText.textContent = window.variantStrings.unavailable;
	  if (price) price.classList.add('hidden');
	  if (inventory) inventory.classList.add('hidden');
	  if (sku) sku.classList.add('hidden');
	  if (pricePerItem) pricePerItem.classList.add('hidden');
	  if (volumeNote) volumeNote.classList.add('hidden');
	  if (volumeTable) volumeTable.classList.add('hidden');
	  if (qtyRules) qtyRules.classList.add('hidden');
	}
  
	getVariantData() {
	  this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
	  return this.variantData;
	}
  }
  
  customElements.define('variant-selects', VariantSelects);